import { NgModule } from '@angular/core'
import { PreloadAllModules, RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../../src/security/models/services/auth'


const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../app/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('../app/authentication/authentication.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'healthcheck',
    loadChildren: () => import('@sightline/health-check').then((m) => m.HealthCheckPageModule),
  },
  {
    path: 'administration',
    loadChildren: () => import('../app/administration/administration.module').then((m) => m.AdministrationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'accounts',
    loadChildren: () => import('../app/accounts/accounts.module').then((m) => m.AccountsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'transactions',
    loadChildren: () => import('../app/transactions/transactions.module').then((m) => m.TransactionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'funds-recovery',
    loadChildren: () => import('../app/funds-recovery/funds-recovery.module').then((m) => m.FundsRecoveryModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('../app/reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'home'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
